export default {
  release: '18.0',
  date: 'May 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/18/gitlab-18-0-released/#this-months-notable-contributor-michael-hofer',
  contributors: [
    {
      name: 'Michael Hofer',
      gitlabUsername: 'karras',
    },
  ],
  writeUp: `Michael Hofer champions GitLab's open source mission as both a top contributor and community leader.
With over [50 contributions](https://contributors.gitlab.com/users/karras?fromDate=2025-01-01&toDate=2025-05-12) this year,
his work strengthened GitLab's Geo features and Secrets Manager, based on OpenBao.
He topped the [April Hackathon](https://contributors.gitlab.com/hackathon?hackathonName=2025_04) while supporting fellow contributors and leading community projects.

"I truly appreciate that everyone can contribute to GitLab!" says Michael.
"The team is great to work with, it's a lot of fun, and everyone is super helpful, especially when we team up across open source initiatives like OpenBao and SLSA."

Michael is the CTO at [Adfinis](https://adfinis.com/en/), an international IT service provider specializing in planning, building, and running mission critical open source workloads.
He is passionate about fostering collaboration and promoting open source solutions across organizations.

Recently, Adfinis participated in GitLab's [Co-Create program](https://about.gitlab.com/community/co-create/), which pairs organizations with GitLab's product and engineering teams
to build GitLab together.
"We highly recommend Co-Create to all organizations," Michael says. "It led to a number of cool contributions, including rootless Podman builds, Glimmer syntax highlighting, and other improvements."

"The Geo Team really appreciates and enjoys working with Michael," says [Lucie Zhao](https://gitlab.com/luciezhao), Engineering Manager at GitLab, who nominated Michael for the award.
"With his excellent contributions over the last few milestones, he has become the most well-known community contributor within our team."

GitLab team members [Lee Tickett](https://gitlab.com/leetickett-gitlab), [Chloe Fons](https://gitlab.com/c_fons), and [Alex Scheel](https://gitlab.com/cipherboy-gitlab) supported the nomination.
Alex adds, "Michael's leadership in OpenBao has enabled us to effectively collaborate in bringing forward a secrets management solution for our customers, with the transparency that aligns with our GitLab values."

Thanks to Michael and the Adfinis team for co-creating GitLab!`,
};
